import React, { FC, type ReactNode, useMemo } from 'react';
import { Stack, type StackProps } from '@mui/material';

interface SeparatedListProps {
  children: ReactNode | ReactNode[];
  separator?: ReactNode;
}

const SeparatedList: FC<SeparatedListProps & StackProps> = ({ children, separator, ...props }) => {
  const childrenList = useMemo(() => (Array.isArray(children) ? children : [children]), [children]);

  return (
    <Stack direction="row" {...props}>
      {childrenList.filter(Boolean).map((item, index) => (
        <React.Fragment key={index}>
          {!!index && separator}
          {item}
        </React.Fragment>
      ))}
    </Stack>
  );
};

export default SeparatedList;
